export const MEDICAL_CAM = 'medical_camera'
export const ECG = 'ecg'
export const OTHER = 'other'
export const STETO = 'stethoscope'
export const VISIO_CONF = 'visioconference'
export const VISIO_CONF_MIC = 'visioconference_micro'

const types = [
  ECG,
  MEDICAL_CAM,
  STETO,
  VISIO_CONF,
  VISIO_CONF_MIC,
  OTHER
]

export default types